import React from 'react';

import Button from '../components/Button';
import Hero from '../components/Hero';
import IndustryList from '../components/IndustryList';
import ContentBlock from '../components/ContentBlock';
import IconContentBlock from '../components/IconContentBlock';
import Section from '../components/Section';
import SectionHero from '../components/SectionHero';
import CodeFeatureCard from '../components/CodeFeatureCard';

import Showcase from '../components/Showcase';

const createMutation = `mutation {
  createPage(
    data: {
      title: "GraphCMS mutation API",
      slug: "graphcms-mutation-api"
    }
  ) {
    id
    title
    slug
  }
}`;

const updateMutation = `mutation {
  updatePage(
    where: {
      slug: "graphcms-mutation-api"
    },
    data: {
      title: "GraphCMS Mutation API!",
    }
  ) {
    id
    title
  }
}`;

const deleteMutation = `mutation {
  deletePage(
    where: {
      slug: "graphcms-mutation-api"
    }
  ) {
    id
    title
  }
}`;

const upsertMutation = `mutation {
  upsertPage(
    where: {
      slug: "graphcms-mutation-api"
    },
    upsert: {
      create: {
        title: "Title created if entry doesn't exist"
      },
      update: {
        title: "Title updated if entry exists"
      }
    }
  ) {
    title
  }
}`;

const manyMutation = `mutation {
  updateManyPages(where: {
    id: "ck7kheagg0mjt0153ldb2hv3r"
  }, data: {
    title: "Updated title"
  }) {
    count
  }
}`;

const publishMutation = `mutation {
  publishPage(
    where: {
      slug: "graphcms-mutation-api"
    },
    to: PUBLISHED
  ) {
    stage
  }
}`;

const mutations = [
  {
    id: 'create',
    language: 'graphql',
    children: createMutation,
    title: 'Create',
    description:
      'Create mutations automatically generated for all your content models.',
  },
  {
    id: 'update',
    language: 'graphql',
    children: updateMutation,
    title: 'Update',
    description: 'Update content entries with a single GraphQL mutation.',
  },
  {
    id: 'delete',
    language: 'graphql',
    children: deleteMutation,
    title: 'Delete',
    description: 'Delete a content entry with a single GraphQL mutation.',
  },
  {
    id: 'upsert',
    language: 'graphql',
    children: upsertMutation,
    title: 'Upsert',
    description: 'Create or Update a content entry with a single mutation.',
  },
  {
    id: 'many',
    language: 'graphql',
    children: manyMutation,
    title: 'Update/Delete Many',
    description:
      'Update or Delete many content entries at once in a single GraphQL mutation.',
  },
  {
    id: 'publishing',
    language: 'graphql',
    children: publishMutation,
    title: 'Publishing',
    description:
      'Publish or Unpublish content entries with a single GraphQL mutation.',
  },
];

const CntentLocalizationBaseTemplate = ({ pageContext: { page } }) => {
  const { contentBlocks, usps } = page;

  return (
    <React.Fragment>
      <Section>
        <Hero {...page}>
          <Button href="/contact" appearance="outline" colour="pink">
            Try GraphCMS for free &#8594;
          </Button>
        </Hero>
      </Section>
      <Section colour="light" size="small">
        <IndustryList entries={contentBlocks} Component={ContentBlock} />
      </Section>
      <Section size="small">
        <SectionHero noHr title="Mutate content with GraphCMS" />
        <div className="md:flex md:flex-wrap -mx-6">
          {usps.map(IconContentBlock)}
        </div>

        <div className="text-center pt-6 md:pt-12">
          <Button href="/contact" appearance="outline" colour="pink">
            Try GraphCMS for free &#8594;
          </Button>
        </div>
      </Section>
      <Section colour="light" size="small" container="narow">
        <SectionHero
          noHr
          title="GraphQL mutations at a glance"
          description="Mutate content via GraphQL with mutations dynamically generated from a custom schema."
        />
        <Showcase
          items={mutations}
          Component={CodeFeatureCard}
          layout="vertical"
        />
      </Section>
    </React.Fragment>
  );
};

export default CntentLocalizationBaseTemplate;
